const sizes = [ 'P', 'M', 'G', 'GG', 'XG', 'EG'];

export const validShirt = (data) => sizes.includes(data);
